// Regra única de datas (igual à da API, api/src/services/common/datas.js):
// - data SEM hora (vencimento, pagamento, data do pedido...) é um dia de
//   calendário gravado como 00:00 UTC. Mostrar pelo fuso do navegador daria o
//   dia anterior (21h do dia antes, em Brasília);
// - data COM hora (createdAt, logs) é o instante real, mostrado no fuso local.
//
// Enquanto a migração dos dados não roda, ainda há datas em 03:00 UTC (lotes)
// e instantes reais em campos sem hora; `diaDe` entende as três formas.

const MS_DIA = 24 * 60 * 60 * 1000;
const TRES_HORAS = 3 * 60 * 60 * 1000;
const p2 = (n) => String(n).padStart(2, "0");
const diaLocal = (d) =>
  `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())}`;

/** "AAAA-MM-DD" de um valor de data sem hora, ou null. */
export const diaDe = (valor) => {
  if (valor === undefined || valor === null || valor === "") return null;
  if (typeof valor === "string") {
    const s = valor.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
    const br = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (br) return `${br[3]}-${br[2]}-${br[1]}`;
  }
  const d = valor instanceof Date ? valor : new Date(valor);
  if (isNaN(d.getTime())) return null;
  const resto = ((d.getTime() % MS_DIA) + MS_DIA) % MS_DIA;
  // 00:00Z (formulário) e 03:00Z (meia-noite de Brasília): o dia em UTC
  if (resto === 0 || resto === TRES_HORAS) return d.toISOString().slice(0, 10);
  // instante real (ex.: new Date() + 7 dias): o dia no fuso local
  return diaLocal(d);
};

/** dd/MM/aaaa de uma data sem hora ("" se vazia ou inválida). */
export const dataCalendario = (valor) => {
  const dia = diaDe(valor);
  return dia ? dia.split("-").reverse().join("/") : "";
};

/** Date local (meia-noite) do dia de calendário, para formatar ou somar dias. */
export const dataLocalDoDia = (valor) => {
  const dia = diaDe(valor);
  if (!dia) return null;
  const [a, m, d] = dia.split("-").map(Number);
  return new Date(a, m - 1, d);
};

// "AAAA-MM-DD" de hoje no fuso do navegador (para campos type="date").
export const hojeISO = () => diaLocal(new Date());

// "AAAA-MM-DD" de hoje + n dias, no fuso do navegador (vencimentos 30/60/90).
export const hojeMaisDias = (dias) => {
  const d = new Date();
  d.setDate(d.getDate() + Number(dias || 0));
  return diaLocal(d);
};
